module.exports = __webpack_public_path__ + "media/images/front/pc/article/thum05-6956a46e9c3d895fb5425877007f16bf.png";